import { Images, QuestionGroup, QuestionType, ScenarioStep, Steps, Translatable } from '../state/interfaces'
import { addressLocation, emailAddress, firstName, internetSpeed, lastName, phoneNumber, thanks } from './common-steps'
import { currentProviderInternet } from './internet-steps'
import { currentProviderMobile } from './mobile-steps'

const calendarLink =
  'https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ2b3cY3uHnUIKynZRan2eLtq4WZIpYB6KtbTa-_NLr0AoNs8YHKmSeV1Ao1f2D93cMUXLLNIybG'

export const emailB2B: ScenarioStep = {
  ...emailAddress,
  question: 'email-address-b2b_question',
  tip: 'email-address-b2b_tip',
  next: Steps.FIRST_NAME,
  metadata: { grandImage: Images.B2B_EMAIL },
}

export const firstNameB2B: ScenarioStep = {
  ...firstName,
  question: 'first-name-b2b_question',
  tip: 'first-name-b2b_tip',
  next: Steps.LAST_NAME,
  metadata: { grandImage: Images.B2B_FIRST_NAME, inputType: 'name' },
}

export const lastNameB2B: ScenarioStep = {
  ...lastName,
  question: 'last-name-b2b_question',
  tip: 'last-name-b2b_tip',
  next: Steps.PHONE_NUMBER,
  metadata: { grandImage: Images.B2B_LAST_NAME, inputType: 'name' },
}

export const phoneNumberB2B: ScenarioStep = {
  ...phoneNumber,
  question: 'phone-number-b2b_question',
  tip: 'phone-number-b2b_tip',
  next: Steps.COMPANY_NAME,
  metadata: { grandImage: Images.B2B_PHONE },
}

export const companyName: ScenarioStep = {
  id: Steps.COMPANY_NAME,
  group: QuestionGroup.DEFAULT,
  question: 'company-name_question',
  tip: 'company-name_tip',
  type: QuestionType.INPUT_DEFAULT,
  answerPlaceholder: 'company-name_answerPlaceholder',
  next: Steps.POSTAL_CODE,
  answers: [],
  metadata: { grandImage: Images.B2B_COMPANY, inputType: 'companyName' },
}

export const postalCode: ScenarioStep = {
  id: Steps.POSTAL_CODE,
  group: QuestionGroup.DEFAULT,
  question: 'postal-code-b2b_question',
  tip: 'postal-code-b2b_tip',
  type: QuestionType.POSTAL_CODE_STANDALONE,
  answerPlaceholder: 'postal-code_answerPlaceholder',
  next: Steps.BUSINESS_CONNECTIVITY,
  answers: [],
  metadata: { grandImage: Images.MOVE },
}

export const businessConnectivity: ScenarioStep = {
  id: Steps.BUSINESS_CONNECTIVITY,
  group: QuestionGroup.DEFAULT,
  question: 'business-connectivity_question',
  tip: 'business-connectivity_tip',
  type: QuestionType.CHOICE_AS_PILLS_LARGE,
  answers: [
    { id: 'mobile-option', text: 'mobile-plans' as Translatable, next: Steps.CURRENT_PROVIDER_MOBILE_B2B },
    { id: 'internet-option', text: 'internet-plans' as Translatable, next: Steps.CURRENT_PROVIDER_INTERNET_B2B },
    {
      id: 'mobile-internet-option',
      text: 'mobile-internet-plans-option' as Translatable,
      next: Steps.CURRENT_PROVIDER_MOBILE_B2B,
    },
  ],
}

export const addressLocationB2B: ScenarioStep = {
  ...addressLocation,
  group: QuestionGroup.DEFAULT,
  question: 'address-location-B2B_question',
  tip: 'address-location-B2B_tip',
  answerPlaceholder: 'address-location-B2B_answerPlaceholder',
  next: Steps.FINAL_WORD_B2B,
}

export const currentProviderInternetB2B: ScenarioStep = {
  ...currentProviderInternet,
  id: Steps.CURRENT_PROVIDER_INTERNET_B2B,
  question: { key: 'current-provider-internet-b2b_question', options: { providerType: 'internet' } },
  next: Steps.INTERNET_SPEED,
}

export const currentProviderMobileB2B: ScenarioStep = {
  ...currentProviderMobile,
  id: Steps.CURRENT_PROVIDER_MOBILE_B2B,
  question: { key: 'current-provider_question', options: { providerType: 'mobile' } },
  next: Steps.HOW_MANY_CELLPHONE_LINES,
}

export const howManyCellPhoneLines: ScenarioStep = {
  id: Steps.HOW_MANY_CELLPHONE_LINES,
  group: QuestionGroup.DEFAULT,
  question: 'how-many-cellphone-lines_question',
  tip: 'how-many-cellphone-lines_tip',
  type: QuestionType.CHOICE_AS_PILLS_LARGE,
  next: Steps.CANADA_US_COVERAGE,
  answers: [
    {
      id: '1-2',
      text: '1-2' as Translatable,
    },
    {
      id: '3-4',
      text: '3-4' as Translatable,
    },
    {
      id: '5-10',
      text: '5-10' as Translatable,
    },
    {
      id: '11-20',
      text: '11-20' as Translatable,
    },
    {
      id: '21-or-more',
      text: '21+' as Translatable,
    },
  ],
}

export const canadaUSCoverage: ScenarioStep = {
  id: Steps.CANADA_US_COVERAGE,
  group: QuestionGroup.DEFAULT,
  question: 'canada-us-coverage_question',
  tip: 'canada-us-coverage_tip',
  type: QuestionType.CHOICE_AS_PILLS_LARGE,
  next: Steps.FINAL_WORD_B2B,
  metadata: { grandImage: Images.HOW_MANY_PEOPLE_WORKING_FROM_HOME },
  answers: [
    {
      id: 'yes',
      text: 'common_yes',
    },
    {
      id: 'no',
      text: 'common_no',
    },
  ],
}

export const finalWordB2B: ScenarioStep = {
  id: Steps.FINAL_WORD_B2B,
  group: QuestionGroup.DEFAULT,
  question: 'final-word-b2b_question',
  tip: 'final-word-b2b_tip',
  type: QuestionType.TEXTAREA,
  answerPlaceholder: 'final-word-b2b_answerPlaceholder',
  next: Steps.BOOK_A_MEEETING,
  answers: [],
}

export const bookAMeeting: ScenarioStep = {
  id: Steps.BOOK_A_MEEETING,
  group: QuestionGroup.DEFAULT,
  question: 'book-a-meeting_question',
  tip: 'book-a-meeting_tip',
  type: QuestionType.CHOICE_AS_PILLS_LARGE,
  next: Steps.THANKS,
  metadata: { grandImage: '' },
  answers: [
    {
      id: 'submit-and-book',
      text: 'submit-and-book' as Translatable,
      metadata: { background: 'brand', followsLink: calendarLink },
    },
    {
      id: 'submit-only',
      text: 'submit-only' as Translatable,
    },
  ],
}

export const thanksB2B: ScenarioStep = {
  ...thanks,
  question: 'thanks-b2b_question',
  tip: 'thanks-b2b_tip',
  answers: [
    {
      id: 'back-to-planhub',
      text: 'back-to-planhub' as Translatable,
    },
  ],
  metadata: { grandImage: '' },
}

export const internetSpeedB2B: ScenarioStep = {
  ...internetSpeed,
  type: QuestionType.CHOICE_AS_PILLS_LARGE,
  tip: 'internet-speed-with-slide_tip',
  metadata: { grandImage: Images.SPEED_SEARCH },
  answers: [
    { id: '10', text: { key: 'common_mbps-amount', options: { count: 10 } }, next: Steps.FINAL_WORD_B2B },
    { id: '30', text: { key: 'common_mbps-amount', options: { count: 30 } }, next: Steps.FINAL_WORD_B2B },
    { id: '60', text: { key: 'common_mbps-amount', options: { count: 60 } }, next: Steps.FINAL_WORD_B2B },
    { id: '100', text: { key: 'common_mbps-amount', options: { count: 100 } }, next: Steps.FINAL_WORD_B2B },
    { id: '500', text: { key: 'common_mbps-amount', options: { count: 500 } }, next: Steps.FINAL_WORD_B2B },
    { id: '900', text: { key: 'common_mbps-amount', options: { count: 900 } }, next: Steps.FINAL_WORD_B2B },
    { id: 'custom-speed', text: 'common_custom-speed', next: Steps.SLIDER_DATA_AMOUNT },
  ],
}

export const internetSpeedB2BB: ScenarioStep = {
  ...internetSpeedB2B,
  answers: [
    { id: '10', text: { key: 'common_mbps-amount', options: { count: 10 } }, next: Steps.ADDRESS_LOCATION },
    { id: '30', text: { key: 'common_mbps-amount', options: { count: 30 } }, next: Steps.ADDRESS_LOCATION },
    { id: '60', text: { key: 'common_mbps-amount', options: { count: 60 } }, next: Steps.ADDRESS_LOCATION },
    { id: '100', text: { key: 'common_mbps-amount', options: { count: 100 } }, next: Steps.ADDRESS_LOCATION },
    { id: '500', text: { key: 'common_mbps-amount', options: { count: 500 } }, next: Steps.ADDRESS_LOCATION },
    { id: '900', text: { key: 'common_mbps-amount', options: { count: 900 } }, next: Steps.ADDRESS_LOCATION },
    { id: 'custom-speed', text: 'common_custom-speed', next: Steps.SLIDER_DATA_AMOUNT },
  ],
}

export const sliderDataB2B: ScenarioStep = {
  id: Steps.SLIDER_DATA_AMOUNT,
  group: QuestionGroup.DEFAULT,
  question: 'slider-data_question',
  type: QuestionType.SLIDER_DATA,
  next: Steps.FINAL_WORD_B2B,
  answers: [],
  metadata: {
    defaultValue: 20,
    min: 0,
    max: 200,
    colorScheme: 'teal',
    sliderMark: [
      {
        value: 0,
        text: '0',
      },
      {
        value: 50,
        text: '50',
      },
      {
        value: 100,
        text: '100',
      },
      {
        value: 200,
        text: '900',
      },
    ],
    dataUnitType: 'Mbps',
    step: 1,
  },
}

export const sliderDataB2BB: ScenarioStep = {
  id: Steps.SLIDER_DATA_AMOUNT,
  group: QuestionGroup.DEFAULT,
  question: 'slider-data_question',
  type: QuestionType.SLIDER_DATA,
  next: Steps.ADDRESS_LOCATION,
  answers: [],
  metadata: {
    defaultValue: 20,
    min: 0,
    max: 200,
    colorScheme: 'teal',
    sliderMark: [
      {
        value: 0,
        text: '0',
      },
      {
        value: 50,
        text: '50',
      },
      {
        value: 100,
        text: '100',
      },
      {
        value: 200,
        text: '900',
      },
    ],
    dataUnitType: 'Mbps',
    step: 1,
  },
}
